export default {
    emptyListContainer: {},
    emptyListText: {}
};
